import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { DateFilterFn } from '@angular/material/datepicker';
import { NewClinicalFeedbackFormHelper } from '@app/clinical-feedback/new-clinical-feedback/new-clinical-feedback.helper';

@Component({
    selector: 'app-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss']
})
export class DateComponent implements OnInit {
    @Input() label!: string;
    @Input() formElementId!: string;
    @Input() isFilteringFutureDates = false;
    @Input() parentFormGroup!: UntypedFormGroup;
    @Input() errorLabel = '';

    ngOnInit() {
        this.setErrorMessage();
    }

    private setErrorMessage() {
        if (!this.errorLabel) {
            this.errorLabel = this.label;
        }
    }

    get control() {
        return this.parentFormGroup.get(this.formElementId) as AbstractControl;
    }

    get asterisk() {
        return NewClinicalFeedbackFormHelper.getAsteriskIfRequired(this.control);
    }

    dateFilter: DateFilterFn<Date | null> = (date: Date | null): boolean =>
        this.isFilteringFutureDates ? (date ?? 0) <= new Date() : true;
}
